import { get } from "../util";

/**
 * Hvilke datoer et påbud eller pålæg vil få, hvis det oprettes med den angivne
 * kendelsesdato og periodelængde.
 *
 * Beregningen ligger i backenden, fordi den afhænger af advokatens udøvende perioder.
 * Et gæt klientside ville lægge reglen to steder — og de to steder ville være uenige
 * netop i bero-tilfældene, som er hele grunden til at fristen beregnes.
 */
export interface FristForhaandsvisningDTO {
  periodeFra: string;
  /** Periodens sidste dag, eller null hvis perioden ikke er udløbet endnu. */
  periodeTil: string | null;
  /** Dokumentationsfristen, eller null hvis forløbet står i bero. */
  frist: string | null;
  erIBero: boolean;
  /**
   * Datoen forløbet gik i bero. Kan være null, selvom `erIBero` er sand: advokaten kan
   * være udøvende i dag, men have en beskikkelse der ophører før perioden er gået.
   */
  iBeroSiden: string | null;
}

export type InjunctionType = "paabud" | "paalaeg";

export const getFristForhaandsvisning = (
  type: InjunctionType,
  personId: string,
  kendelseDato: string,
  periodeLaengdeMaaneder: number,
): Promise<FristForhaandsvisningDTO> =>
  get<FristForhaandsvisningDTO>({
    query:
      `person/${encodeURIComponent(personId)}/${type}/fristforhaandsvisning` +
      `?kendelseDato=${encodeURIComponent(kendelseDato)}` +
      `&periodeLaengdeMaaneder=${periodeLaengdeMaaneder}`,
  });
